import { styled, Typography } from '@ori-ui/mui';
import type { FC, ReactChild } from 'react';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { localization } from '../../shared/constants';

interface ReviewPriceProps {
  readonly action?: ReactChild;
  readonly price?: string;
  readonly labelKey: keyof typeof localization;
}

const ReviewPrice = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `
  "label price action"
  `,
  gridTemplateColumns: '1fr auto auto',
  alignItems: 'center',
  columnGap: theme.spacing(1),
}));

const PriceReviewComponent: FC<ReviewPriceProps> = ({ labelKey, price, action }) => (
  <ReviewPrice>
    <Typography sx={{ gridArea: 'label' }}>
      <strong>
        <FormattedMessage
          id={labelKey}
          defaultMessage={localization[labelKey]}
        />
      </strong>
    </Typography>
    <Typography sx={{ gridArea: 'price' }}>
      <strong>{price}</strong>
    </Typography>
    <div style={{ gridArea: 'action' }}>{action}</div>
  </ReviewPrice>
);

const PriceReview = memo(PriceReviewComponent);

export default PriceReview;
